import React, { useRef, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from "sweetalert2";
import { GET, POST } from "../../services/AxiosService";
import Form from "react-bootstrap/Form";

//
import logo from '../../images/logoBraille.png'
import ReCAPTCHA from 'react-google-recaptcha';

function Login(props) {
	const router = useNavigate();
	const [formData, setFormData] = useState({
		noHp: "",
		password: "",
	});
	const [validated, setValidated] = useState(false);
	const [captchaValue, setCaptchaValue] = useState(null);
	const recaptchaRef = useRef(null);


	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));

		// Validasi form di sini
		const form = e.currentTarget.form;
		const isValid = form.checkValidity();
		setValidated(isValid);
		if (isValid) {
			form.classList.remove("was-validated");
		} else {
			form.classList.add("was-validated");
		}
	};

	const handleCaptchaChange = (value) => {
		setCaptchaValue(value);
	};

	const resetCaptcha = () => {
		if (recaptchaRef.current) {
			recaptchaRef.current.reset();
			setCaptchaValue(null);
		}
	};

	function callback(res) {
		Swal.close();
		Swal.fire({
			icon: "error",
			title: `${res.data.message}`,
		});
		resetCaptcha();
	}

	const handleLogin = async (e) => {
		e.preventDefault();
		if (!captchaValue) {
			Swal.fire({
				icon: "error",
				title: "Verifikasi gagal",
				text: "Harap centang captcha terlebih dahulu.",
			});
			return;
		}


		const requestBody = {
			noHp: formData.noHp,
			password: formData.password,
			captchaToken: captchaValue
		};

		Swal.fire({
			title: "Logging in...",
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading();
			},
		});

		const res = await POST(`/auth/login-web`, requestBody, callback, {}, resetCaptcha);
		if (res) {
			Swal.close();
			Swal.fire(
				// `${res.data.message}`,
				"Login Sukses"
				// "You clicked the button!",
				// "success"
			);

			const token = res.access_token;
			const refresh_token = res.refresh_token;
			const access_id = res.access_id;
			const access_name = res.access_name;
			const access_role = res.access_role;
			const access_resource = res.access_resource;
			// const role = res.access_role;
			// const name = res.access_name;

			// const photo = res.data.photo;


			localStorage.setItem("accessToken", token);
			localStorage.setItem("refreshToken", refresh_token);
			localStorage.setItem("accessId", access_id);
			localStorage.setItem("accessName", access_name);
			localStorage.setItem("accessRole", access_role);

			access_resource.forEach((item) => {
				const existingActions = JSON.parse(localStorage.getItem(item.name)) || [];
				if (!existingActions.includes(item.action)) {
					existingActions.push(item.action);
				}
				localStorage.setItem(item.name, JSON.stringify(existingActions));
			});
			// localStorage.setItem("name", name);
			// localStorage.setItem("accesRole", role);
			// localStorage.setItem("email", email);
			// localStorage.setItem("accessFullname", fullname);
			// localStorage.setItem("foodcourt", foodcourt);
			// localStorage.setItem("photo", photo);

			// console.log(token);
			// console.log(data);

			// {localStorage.getItem('accesRole') === 'tenant' ? (
			//   router("/tenant/dashboard")
			// ) : (
			//   router("/")
			// )}

			// if (role === "pengantar") {
			// 	router("/pengantar/order");
			// } else {
			// 	router("/");
			// }
			router("/");
		}
	};

	const [version, setVersion] = useState("");
  const initialVersionRef = useRef(null);
  const fetchVersion = async () => {
	try {
	  const res = await GET(`/master-data/version-cms`);
	  if (res?.data && res.data.length > 0) {
		const rawVersionString = res.data[0].name;
		let formattedVersion = rawVersionString;

		// Format the version string (same logic you had in Footer)
		if (rawVersionString && rawVersionString.length === 5) {
		  const major = rawVersionString.slice(0, 1);
		  const minor = rawVersionString.slice(1, 3);
		  const patch = rawVersionString.slice(3, 5);
		  formattedVersion = `${major}.${minor}.${patch}`;
		}

		// Set the version in state to pass to Footer
		setVersion(formattedVersion);

		// --- This is the new refresh logic ---
		if (initialVersionRef.current === null) {
		  // If this is the first time, set the initial version
		  initialVersionRef.current = formattedVersion;
		} else {
		  // On subsequent checks, compare to the initial version
		  if (initialVersionRef.current !== formattedVersion) {
			// New version detected! Refresh the page.
			console.log(
			  `New version detected. Old: ${initialVersionRef.current}, New: ${formattedVersion}. Refreshing...`
			);
			window.location.reload(true);
		  }
		}
	  }
	} catch (error) {
	  console.error("Failed to fetch version:", error);
	}
  };

  useEffect(() => {
	// 1. Fetch the version immediately when the layout loads
	fetchVersion();

	// 2. Set up a "poller" to check for a new version every 5 minutes
	// 1000 milliseconds = 1 second
	const intervalId = setInterval(fetchVersion, 1000);

	// 3. Clean up the interval when the component unmounts
	return () => clearInterval(intervalId);
  }, []); 


	return (
		<div className="vh-100 d-flex justify-content-center align-items-center flex-column">
			<div className="bg-white p-4" style={{ width: "800px" }}>
				<div className="mb-4">
					<div className="d-flex">
						<img src={logo} alt="" width={140} height={40} className="logo-icon mr-2" />
						<h3 className="mb-1 p-2 font-w600">Yayasan Hikmah Mata Hati</h3>
					</div>
					<p style={{ fontSize: "21px" }}>Selamat Datang di Yayasan Hikmah Mata Hati</p>
				</div>

				<form onSubmit={handleLogin} noValidate validated={validated}>
					<div className="form-group">
						<label className="mb-2 ">
							<strong className="">Nomor HP</strong>
						</label>
						<input name="noHp" type="text" className="form-control" placeholder="Masukkan nomor HP" maxLength="14" pattern="[0-9]{8,}" required value={formData.noHp}
							// onChange={handleChange}
							onChange={(e) => {
								const { value } = e.target;
								// Hanya karakter angka
								const numericValue = value.replace(/\D/g, "");
								setFormData((prevState) => ({
									...prevState,
									noHp: numericValue,
								}));
								const form = e.currentTarget.form;
								const isValid = form.checkValidity();
								setValidated(isValid);
								if (isValid) {
									form.classList.remove("was-validated");
								} else {
									form.classList.add("was-validated");
								}
							}}
						/>
						<Form.Control.Feedback type="invalid">
							Nomor HP harus diisi.
						</Form.Control.Feedback>
					</div>
					<div className="form-group">
						<label className="mb-2"><strong className="">Password</strong></label>
						<input name="password" type="password" className="form-control" placeholder="Masukkan password" maxLength="199" required value={formData.password} onChange={handleChange} />
						<Form.Control.Feedback type="invalid">
							Password harus diisi.
						</Form.Control.Feedback>
					</div>
					{/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
									<div className="form-group">
										<div className="custom-control custom-checkbox ml-1 ">
											<input type="checkbox" className="form-check-input" id="basic_checkbox_1"/>
											<label className="form-check-label" htmlFor="basic_checkbox_1">Remember my preference</label>
										</div>
									</div>
								</div> */}
					<div className="d-flex justify-content-between align-items-center mt-3 mb-3">
						<ReCAPTCHA
							ref={recaptchaRef}
							sitekey={process.env.REACT_APP_SITE_KEY_CAPTCHA}
							onChange={handleCaptchaChange}
						/>
					</div>
					<div className="text-center">
						<button type="submit" className="btn btn-primary btn-block" disabled={!validated}>Masuk</button>
					</div>
				</form>
			</div>

			<div className="copyright text-center mt-3">
				<p className="mb-0">
					{version && <span style={{ marginRight: "5px" }}>Version {version} | Copyright © {new Date().getFullYear()} Matahati</span>}
				</p>
			</div>
		</div>
	)
}

export default Login